/**
 * Este archivo contiene la lógica de permisos.
 * TEMPORALMENTE MODIFICADO PARA PERMITIR ACCESO TOTAL A TODOS LOS USUARIOS.
 * La lógica de roles se ha desactivado devolviendo 'true' en todas las funciones.
 */

// --- Funciones de gestión por módulo (todas activadas) ---
export const canManageUsers = (user) => true;
export const canManageContacts = (user) => true;
export const canManageDevices = (user) => true;
export const canManageSubscriptions = (user) => true;
export const canManageTemplates = (user) => true;
export const canViewSettings = (user) => true;

// --- Funciones de acción CRUD (todas activadas) ---
export const canCreate = (user) => true;
export const canEdit = (user) => true;
export const canDelete = (user) => true;
export const canRead = (user) => true; 